import { createContext, useContext } from 'react';

import type { BootstrapTheme } from '@/types/theme';

interface ThemeContextType {
  readonly currentTheme: BootstrapTheme;
  readonly setTheme: (themeId: string) => void;
  readonly availableThemes: readonly BootstrapTheme[];
}

export const ThemeContext = createContext<ThemeContextType | undefined>(
  undefined
);

export function useTheme(): ThemeContextType {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeContextProvider');
  }
  return context;
}
